import React from "react";
import {connect} from "react-redux";
import {hashHistory} from "react-router";

import PricingTopPanelSearch from "./PricingTopPanelSearch";
import PricingTopPanelButtons from "./PricingTopPanelButtons";
import PricingNotification from "./PricingNotification";


const PricingTopPanel = (props) => {

  const {} = props;

  const backToListClick = () => {
    // hashHistory.push(ROUTES.pricing);
  }

  return (
    <div className="pr-top-panel bg-black3 border-box radius-5 p-1 flex flex--center flex--between">
      <div className="flex flex--center flex--start flex-item">
        <ul className="fix-ul flex flex--center margin-r8">
          <li className="pr-block margin-r8 p-025 radius-8 flex flex--column link" onClick={backToListClick}>
            <span className="block bold font--12 line--12">Quotes</span>
            <span className="block bold font--14 line--14">65</span>
          </li>
          <li className="pr-block margin-r8 p-025 radius-8 flex flex--column link" onClick={backToListClick}>
            <span className="block bold font--12 line--12">Orders</span>
            <span className="block bold font--14 line--14">65</span>
          </li>
          <li className="pr-block margin-r8 p-025 radius-8 flex flex--column link" onClick={backToListClick}>
            <span className="block bold font--12 line--12">Price Lists</span>
            <span className="block bold font--14 line--14">10</span>
          </li>
        </ul>
        <PricingTopPanelSearch/>
      </div>
      <PricingTopPanelButtons/>
      <PricingNotification/>
    </div>
  )
};

const mapStateToProps = (store) => {
  return {
    language: store.dashboardState.language,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PricingTopPanel);
